module.exports = __webpack_public_path__ + "img/2.3d396d5e.jpg";